export function formatDate(date) {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(
    2,
    "0"
  )}-${String(date.getDate()).padStart(2, "0")}`;
}

export function endOfDay(formattedDateString) {
  let endOfDay = new Date(formattedDateString);
  endOfDay.setHours(23, 59, 59, 999);
  return endOfDay;
}

export function capitalise(str) {
  if (!str) return str;
  return str
    .split(/[ _-]/g)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}
